export const getDocumentFilepaths = (dto: {
  attachments?: string[] | string;
  scan?: string[] | string;
}) => {
  return [dto.attachments, dto.scan].flat().filter((filePath) => filePath !== undefined);
};
